import { useUserStore } from '@/stores/userStore'

import type { AxiosInstance } from 'axios'

export function setAuthorizationInterceptor(client: AxiosInstance): void {
  client.interceptors.request.use(
    config => {
      const userStore = useUserStore()
      const token = userStore.token
      if (token) config.headers.Authorization = `Bearer ${token}`

      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
}

export function setRefreshOnExpireInterceptor(client: AxiosInstance): void {
  client.interceptors.response.use(
    response => {
      return response
    },
    async error => {
      if (error.config.url.includes('logout')) {
        return Promise.reject(error)
      }
      if (error.config.url.includes('auths')) {
        return Promise.reject(error)
      }

      const userStore = useUserStore()
      const refreshToken = userStore.refreshToken
      const errorIs401 = error.response?.status === 401
      const errorIsExpired =
        error.response?.data.error === 'Token invalid due to new login'
      if (errorIsExpired && errorIs401 && refreshToken) {
        try {
          await userStore.refresh()
          return client.request(error.config)
        } catch (e) {
          await userStore.logout()
          return Promise.reject(e)
        }
      }

      return Promise.reject(error)
    }
  )
}
